<template>
	<footer>
    <div :class="`foot-main ${plat}`">
      <div class="foot foot-01">
        <div class="footin">
          <p class="foot-tit">
            <img src="../../assets/img_logo02_p.png" alt="logo">
          </p>
          <div :style="msy">
            <p class="foot-tit">搜盈趣科技，关注最新动态</p>
            <div class="footicon">
              <div class="fIcon">
                <img src="../../assets/img_wechat.png" alt="微信">
                <span class="hIcon"><img src="../../assets/img_wechat_code.png" alt=""></span>
              </div>
              <div class="fIcon">
                <img src="../../assets/icon_tiktok.png" alt="抖音">
                <span class="hIcon"><img src="../../assets/img_tiktok_code.png" alt=""></span>
              </div>
              <div class="fIcon">
                <img src="../../assets/icon_weibo.png" alt="微博">
                <span class="hIcon"><img src="../../assets/img_weibo_code.png" alt=""></span>
              </div>
            </div>
          </div>
          <div :style="psy">
            <p style="margin-bottom: 8px">@copy;2021厦门盈趣科技股份有限公司</p>
            <p>备案号：闽ICP备11015268号-1</p>
          </div>
        </div>
      </div>
      <div class="foot foot-02">
        <div class="footin">
          <p class="foot-tit">相关网站</p>
          <ul class="footaddr">
            <li>
              <a class="jumplink" href="http://www.intretech.com/" target="_blank">盈趣科技</a>
              <a class="jumplink" href="http://www.umsin.com/" target="_blank">攸信技术</a>
            </li>
            <li>
              <a class="jumplink" href="http://www.intrehome.com" target="_blank">盈趣智能管家</a>
              <a class="jumplink" href="http://www.coming-tek.com/" target="_blank">上海开铭</a>
            </li>
            <li>
              <a class="jumplink" href="http://www.memobird.cn" target="_blank">Memobird</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="foot foot-03" :style="psy">
        <div class="footin">
          <p class="foot-tit">搜盈趣科技，关注最新动态</p>
          <div class="footicon">
            <div class="fIcon">
              <img src="../../assets/img_wechat.png" alt="微信">
              <span class="hIcon"><img src="../../assets/img_wechat_code.png" alt=""></span>
            </div>
            <div class="fIcon">
              <img src="../../assets/icon_tiktok.png" alt="抖音">
              <span class="hIcon"><img src="../../assets/img_tiktok_code.png" alt=""></span>
            </div>
            <div class="fIcon">
              <img src="../../assets/icon_weibo.png" alt="微博">
              <span class="hIcon"><img src="../../assets/img_weibo_code.png" alt=""></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
	export default {
		props: {
		},
    data() {
    return {
      plat: `plat-${this.$store.state.plat}`,
      psy: { display: this.$store.state.plat === 'Web' ? '' : 'none' },
      msy: { display: this.$store.state.plat === 'Mobile' ? '' : 'none' },
    }
  },
		methods: {
		}
	}
</script>

<style lang="less" rel="stylesheet/less"  scoped>
  p {
    padding: 0;
    margin: 0;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .foot-main {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 250px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    background: #1F2329;
    padding: 35px 12vw;
    box-sizing: border-box;
    &.plat-Mobile {
      flex-direction: column;
      height: 300px;
      padding: 0;
      .foot {
        width: calc(100% - 40px);
        margin: 0 20px;
        &:nth-child(2) {
          border: none;
          border-top: 1px solid rgba(255, 255, 255, .1);
        }
        .footin {
          margin: 0;
          // display: flex;
          // flex-direction: column;
          // justify-content: center;
          // align-items: flex-start;
        }
      }
      .foot-tit {
        img {
          width: 120px;
        }
      }
      .footicon {
        margin: 0px;
        img {
          width: 25px;
          height: 25px;
        }
        .fIcon {
          pointer-events: none;
          &:hover {
            .hIcon {
              display: none;
            }
          }
        }
      }
    }
    // PC
    .foot {
      width: 33.33%;
      height: 100%;
      box-sizing: border-box;
      display: flex;
      &:nth-child(2) {
        border-left: 1px solid rgba(255, 255, 255, .1);
        border-right: 1px solid rgba(255, 255, 255, .1);
      }
      .footin {
        // width: max-content;
        height: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
      }
    }
  }
  .foot-tit {
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
    margin-bottom: 15px;
    img {
      width: 200px;
    }
  }
  .footaddr {
    color: #fff;
    li {
      height: 28px;
      line-height: 28px;
      a.jumplink {
        width: 120px;
        display: inline-block;
        text-decoration: none;
        color: #fff;
        cursor: pointer;
        font-size: 12px;
      }
    }
  }
  .footicon {
    margin: 50px 0 0 0;
    img {
      width: 35px;
      height: 35px;
      margin-right: 15px;
      cursor: pointer;
    }
    .fIcon {
      float: left;
      position: relative;
      cursor: pointer;
      &:hover {
        .hIcon {
          display: block;
        }
      }
      .hIcon {
        display: none;
        position: absolute;
        top: -195px;
        left: -75px;
        z-index: 20;
        img {
          width: 184px;
          height: auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue